import {IApiConfig} from "@tools/CustomInterfaces";

const data : IApiConfig[] = [
    {
        "name" : "readNotificationCount",
        "tag" : "notification",
        "value": "readNotificationCount"
    },
    {
        "name" : "updateNotificationAsRead",
        "tag" : "notification",
        "value": "updateNotificationAsRead"
    }
]

export default data;
